/* eslint-disable jsx-a11y/label-has-associated-control */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingAnimation from '../../../../../components/LoadingAnimation';
import { getAsync } from '../../../../../components/helper/axiosHelper';
import { handleFileDownload } from '../../../../../libs';
import { PageHitCountApi } from '../../../../../shared/Helper';
import { DetailAccordion } from '../../sd/DetailAccordion';
import '../gwaStyles.css';

export default function UpdateGWARegister() {
  const { id } = useParams();
  const [ep_Photo, setEP_Photo] = useState('');
  const [eP_ID, setEP_ID] = useState('');
  const [mainData, setMainData] = useState([]);
  const [limitRequest, setLimitRequest] = useState(true);
  const [countryAPIData, setCountryAPIData] = useState([]);
  const [gwaTypeID, setGwaTypeID] = useState(0);
  const [regReason, setRegReason] = useState('');
  const [personnel, setPersonnel] = useState('');
  const [institute, setInstitute] = useState('');
  const [workplace, setWorkplace] = useState('');
  const [website, setWebsite] = useState('');
  const [fileName, setFileName] = useState('');
  const [EP_IDBase64URL, setEP_IDBase64URL] = useState('');
  const [mediaData, setMediaData] = useState([]);
  const [nationalityAPIData, setNationalityAPIData] = useState([]);
  const [selectedNationalityID, setSelectedNationalityID] = useState(0);
  const [allowedFileExtensions, setAllowedFileExtensions] = useState(['png', 'jpg', 'jpeg', 'pdf']);
  const [inputEP_IDFileSize, setInputEP_IDFileSize] = useState('');
  const [inputEP_IDFile, setinputEP_IDFile] = useState('');
  const [ep_IDCheck, setEP_IDcheck] = useState('');
  const [visible, setVisible] = useState(false);
  const [accountHandelMappingList, setAccountHandelMappingList] = useState([{ siteID: 0, accountName: '' }]);
  const [countryName, setCountryName] = useState('');
  const [nationalityName, setNationalityName] = useState('');
  const [accountHandleMapList, setAccountHandleMapList] = useState([]);
  const [ep_PhotofileType, setEp_PhotofileType] = useState('');
  const [archivetypeId, setArchivetypeId] = useState();
  const [epUserID, setEpUserID] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const isActive = useSelector((state) => state.toggle.isActive);
  const { pathname } = useLocation();

  const isLogin = () => {
    if (!token && !epUserID) {
      navigate('/managementLogin');
    }
  };
  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);
  useEffect(() => {
    localStorage.setItem('isHome', false);
    getCountries();
    getNationality();
    isLogin();
    // getEPUserData(id)
    getData(id);
  }, []);

  const getPhotoBase64 = (EpPhotoFile) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(EpPhotoFile);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const getEP_IDBase64 = (eP_ID) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(eP_ID);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const getLicenseBase64 = (EpLicenceFile) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the License to base64 text
      reader.readAsDataURL(EpLicenceFile);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleEP_ID = (eP_ID) => {
    const inputEP_IDFileExtension = eP_ID.target.files[0]?.name?.split('.').pop();
    setEP_IDcheck(inputEP_IDFileExtension);
    let selectedPhoto = eP_ID.target.files[0];
    setinputEP_IDFile(selectedPhoto.name?.substring(0, 100));
    if (selectedPhoto) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const fileSize = selectedPhoto.size;
        setInputEP_IDFileSize(fileSize);
      };
      reader.readAsDataURL(selectedPhoto);
    }

    if (allowedFileExtensions.includes(inputEP_IDFileExtension) && inputEP_IDFileSize < 2097152) {
      getEP_IDBase64(selectedPhoto)
        .then((result) => {
          selectedPhoto['base64'] = result;
          setEP_IDBase64URL(result);
          setEP_ID(selectedPhoto);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getCountries = async () => {
    await getAsync('Utilities/GetCountryList', {
      id: id,
    })
      .then((response) => {
        setCountryAPIData(response?.data);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getNationality = async () => {
    try {
      const response = await getAsync('Utilities/GetNationalityList');
      const nationalityData = response?.data;

      setNationalityAPIData(nationalityData);

      if (nationalityData) {
        nationalityData?.forEach((data) => {
          const nationalityNameEng = data?.settingsNationalityID === selectedNationalityID ? data.nationality_eng : '';

          if (nationalityNameEng !== '' && nationalityNameEng !== null) {
            return setNationalityName(nationalityNameEng);
          }
        });
      }
    } catch (error) {
      console.error('Error fetching nationality data:', error);
      // Handle the error as needed
    }
  };

  const handleChange = (e, index, field) => {
    e.preventDefault();
    const { value } = e.target;
    const onChangeVal = [...accountHandelMappingList];
    onChangeVal[index][field] = value;
    setAccountHandelMappingList(onChangeVal);
  };

  //GET dataById for upadate

  const getData = async (id) => {
    setIsLoading(true);

    await getAsync('GWAService/GetGWAServiceByEPUserId', { id: id }, 'application/json')
      .then((response) => {
        const result = response?.data[0];
        // setMediaData(response?.data[0].archiveMediaModelList);
        // setCountryName(result?.countryName);
        // setWebsite(result?.website);
        // setSelectedNationalityID(result?.nationalityID);
        // setRegReason(result?.regReason);
        // setGwaTypeID(result?.gwaTypeID);
        // setFileName(response?.data[0].archiveMediaModelList[0].fileName);
        // setAccountHandleMapList(response?.data[0].accountHandelMappingList);
        // setEP_Photo(response?.data[0].archiveMediaModelList[0].doc);
        // setEp_PhotofileType(response?.data[0].archiveMediaModelList[0].fileType);
        // setArchivetypeId(response?.data[0].archiveMediaModelList[0].settingsArchivetypeId);
        setMainData(response?.data[0]);
        setMediaData(response?.data[0]?.archiveMediaModelList);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const foundNationality = nationalityAPIData?.find(
    (element) => element?.settingsNationalityID == mainData?.nationalityID,
  );

  const foundCountry = countryAPIData?.find((element) => element?.countryID == mainData?.residentCountryID);

  return (
    <div className="container-fluid ">
      <div className="row justify-center py-5 mt-3">
        <div className="col-xl-11">
          <form>
            <div className="shadow-md  rounded-md ">
              <div style={{ textAlign: 'center' }} className="card-header">
                <h3 className="font-bold py-3 sm:text-2xl  text-xl text-customgreen">
                  {t('Good Will Ambassador Register View')}{' '}
                </h3>
              </div>
              <hr />
              {isLoading ? (
                <LoadingAnimation />
              ) : (
                <div className="card-body md:p-10">
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Personal Details')}</h2>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography></Typography>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label className="text-gray-700 p-2  text-pretty text-sm">
                              {t('User Type')} <span className="errmsg">*</span>
                            </label>
                            <br />
                            <label style={{ margin: '10px' }} className="text-gray-700 p-2  text-pretty text-sm">
                              <input
                                className="w-4 h-4 mb-1 border border-gray-300 text-customgreen rounded-lg focus:ring-customgreen focus:border-customgreen"
                                disabled
                                style={{ marginRight: '5px', cursor: 'no-drop' }}
                                type="radio"
                                // defaultChecked={ mainData?.gwaTypeID == 1 ? true : false }
                                defaultChecked={mainData?.gwaTypeID == 1 ? true : false}
                                name="userType"
                                value={mainData?.gwaTypeID}
                              />
                              {t('Institute')}
                            </label>
                            <label className="text-gray-700 p-2  text-pretty text-sm">
                              <input
                                disabled
                                className="w-4 h-4 mb-1 border border-gray-300 text-customgreen rounded-lg focus:ring-customgreen focus:border-customgreen"
                                style={{ marginRight: '5px', cursor: 'no-drop' }}
                                type="radio"
                                name="userType"
                                defaultChecked={mainData?.gwaTypeID == 2 ? true : false}
                                value={mainData?.gwaTypeID}
                              />
                              {t('Personal')}
                            </label>
                          </div>
                        </div>

                        {mainData?.gwaTypeID == 2 && (
                          <div className="col-lg-6 mb-4">
                            <div className="form-group">
                              <label className="text-gray-700 p-2  text-pretty text-sm">
                                {t('Workplace')}
                                <span className="errmsg">*</span>
                              </label>
                              <input
                                value={mainData?.workPlace}
                                disabled
                                style={{
                                  cursor: 'no-drop',
                                }}
                                type="text"
                                className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen readonly"
                              />
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="row">
                        <div className="col-lg-6 mb-4">
                          <div className="form-group">
                            <label className="text-gray-700 p-2  text-pretty text-sm">
                              {t('Nationality')} <span className="errmsg">*</span>
                            </label>
                            {foundNationality && (
                              <input
                                value={isActive ? foundNationality.nationality_t : foundNationality.nationality_eng}
                                disabled
                                style={{
                                  cursor: 'no-drop',
                                }}
                                type="text"
                                className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen readonly"
                              />
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group">
                            <label className="text-gray-700 p-2  text-pretty text-sm">
                              {t('Resident Country')}
                              <span className="errmsg">*</span>
                            </label>
                            {foundCountry && (
                              <input
                                value={isActive ? foundCountry.ar_SA : foundCountry?.en_US}
                                disabled
                                style={{
                                  cursor: 'no-drop',
                                }}
                                type="text"
                                className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen readonly"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                  <br />

                  <DetailAccordion
                    limitRequest={limitRequest}
                    mediaData={mediaData}
                    handleFileDownload={handleFileDownload}
                    title={'Document Details'}
                    eP_ID={eP_ID}
                  />
                  <br />

                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Account Details')}</h2>
                    </AccordionSummary>
                    <AccordionDetails className="px-4">
                      {/* <Typography style={ { fontWeight: 'bold', fontSize: '18px' } }>
                          { t('Confirmation') }
                        </Typography> */}
                      <div className="row ">
                        <div className=" mb-4 px-0">
                          <div className="form-group">
                            <label className="text-gray-700 p-2  text-pretty text-sm">{t('Website')}</label>
                            <input
                              value={mainData?.website}
                              disabled
                              style={{
                                cursor: 'no-drop',
                              }}
                              type="text"
                              className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen readonly"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row  overflow-x-auto">
                        <table className="table w-full ">
                          <thead className="text-gray-200 text-sm font-medium  uppercase bg-customgreen">
                            <tr>
                              <td className="py-3  uppercase   p-2 text-white  text-pretty">{t('sNo')}</td>
                              <td className="py-3    uppercase  p-2 text-white   text-pretty">{t('Account Name')}</td>
                              <td className="py-3 uppercase  p-2 text-white   text-pretty">{t('Account Title')}</td>
                            </tr>
                          </thead>
                          {mainData?.accountHandelMappingList?.map((item, index) => (
                            <tbody className="text-sm text-gray-700" key={index}>
                              <tr>
                                <td className="py-3  p-2">{index + 1}</td>
                                <td className="py-3   p-2">{item.accountName}</td>
                                <td className="py-3   p-2">{t(`${item.siteName}`)}</td>
                              </tr>
                            </tbody>
                          ))}
                        </table>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                  <br />

                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Extra')}</h2>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography></Typography>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label className="text-gray-700 p-2  text-pretty text-sm">
                            {t('Reason')} <span className="errmsg">*</span>
                          </label>
                          <textarea
                            style={{ height: '100px', cursor: 'no-drop' }}
                            value={mainData?.regReason}
                            className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                            minLength="1"
                            maxLength="500"
                            disabled
                          />
                        </div>
                      </div>
                      {/* <div className="col-lg-12">
                      <div className="form-group">
                        <label className="text-gray-700 p-2  text-pretty text-sm">
                          { t('Managed Notes') } <span className="errmsg">*</span>
                        </label>
                        <textarea
                          style={ { height: '100px' } }
                          value={ maNotes }
                          onChange={ (e) => setMaNotes(e.target.value) }
                          className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          minLength="1"
                          maxLength="500"
                        />
                      </div>
                    </div> */}
                    </AccordionDetails>
                  </Accordion>
                </div>
              )}

              <div className="card-footer md:px-10 py-2 ">
                <Link
                  to={'/GWAManageList'}
                  className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm w-20 py-2.5 text-center me-1"
                >
                  {t('Back')}
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
